import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      initialized: false,
      viewMode: null, // 'platform_admin', 'company_admin', 'end_user'

      initialize: () => {
        const token = get().token;
        if (token) {
          get().fetchUser();
        } else {
          set({ initialized: true });
        }
      },

      setViewMode: (mode) => {
        set({ viewMode: mode });
      },

      fetchUser: async () => {
        try {
          const response = await api.get('/auth/me');
          set({
            user: response.data.user,
            isAuthenticated: true,
            initialized: true
          });
        } catch (error) {
          set({
            user: null,
            token: null,
            isAuthenticated: false,
            initialized: true
          });
        }
      },

      login: async (email, password) => {
        try {
          const response = await api.post('/auth/login', { email, password });
          const { token, user } = response.data;

          // Set default view mode based on user type
          let defaultViewMode = null;
          if (user.userType === 'PLATFORM_ADMIN') {
            defaultViewMode = 'platform_admin';
          } else if (user.userType === 'FIRM_USER' || user.userType === 'COMPANY_USER') {
            defaultViewMode = 'company_admin';
          } else if (user.userType === 'END_USER') {
            defaultViewMode = 'end_user';
          }

          set({
            token,
            user,
            isAuthenticated: true,
            viewMode: defaultViewMode
          });

          // Set default auth header
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

          return { success: true };
        } catch (error) {
          return {
            success: false,
            error: error.response?.data?.error?.message || 'Login failed'
          };
        }
      },

      logout: async () => {
        try {
          await api.post('/auth/logout');
        } catch (error) {
          // Ignore logout errors
        }

        set({
          user: null,
          token: null,
          isAuthenticated: false,
          viewMode: null
        });

        delete api.defaults.headers.common['Authorization'];
      },

      updateUser: (userData) => {
        set({ user: { ...get().user, ...userData } });
      }
    }),
    {
      name: 'acquiva-auth',
      partialize: (state) => ({ token: state.token, viewMode: state.viewMode })
    }
  )
);

// Initialize auth header from stored token
const storedToken = JSON.parse(localStorage.getItem('acquiva-auth'))?.state?.token;
if (storedToken) {
  api.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
}
